import { render, staticRenderFns } from "./DrupalPriceDefault.vue?vue&type=template&id=dd6f79e8"
import script from "./DrupalPriceDefault.vue?vue&type=script&lang=js"
export * from "./DrupalPriceDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../gestion-tache-vuejs-v2/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports